export const SUPPORTED_TYPES = [
  'authorizationForm',
  'serviceAgreement',
  'wasteProfile',
  'wasteProfileChange',
  'wasteProfileRecertify',
  'wasteProfileDeepwell',
  'wasteServiceRequest',
  'wasteProfileChangeRecertify',
  'wasteProfileExpress',
  'manifest',
] as const;

export type DataItemType = typeof SUPPORTED_TYPES[number];
